import { useIntl } from "react-intl";

const intl = useIntl

const credentialOrigins = () => {
  const credentialOriginsArray = [
      {
        label: intl().formatMessage({ id: "contract" }),
        value: "CONTRACT",
      },
      {
        label: intl().formatMessage({ id: "ecommerce" }),
        value: "E-COMMERCE",
      },
      {
        label: intl().formatMessage({ id: "bonus" }),
        value: "BONUS",
      },
  ];

  return credentialOriginsArray;
}

export default credentialOrigins;
